import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable()
export class AddPhotosToGridService {

    public _uploader: BehaviorSubject<any> = new BehaviorSubject<any>('');
    public uploader: Observable<any> = this._uploader.asObservable();

    public _addPhotosHeader: BehaviorSubject<any> = new BehaviorSubject<any>(true);
    public addPhotosHeader: Observable<any> = this._uploader.asObservable();

    public addPhotos(add: boolean) {
        this._uploader.next(add);
    }

    public hideAddPhotosHeader(show: boolean) {
        this._addPhotosHeader.next(show);
    }
}
